import React from 'react';
import { Calendar as CalendarIcon } from 'lucide-react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover';

/**
 * <DatePicker value="YYYY-MM-DD" | "" onChange={(yyyymmdd) => ...} />
 * Wraps shadcn Calendar inside a Popover. Replaces native <input type="date">.
 */
export default function DatePicker({ value, onChange, placeholder = 'Choisir une date', testId, disabled = false, className }) {
    const dateValue = value ? new Date(value + 'T00:00:00') : undefined;
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    type="button"
                    variant="outline"
                    disabled={disabled}
                    className={cn(
                        'w-full h-10 justify-start font-body text-sm font-normal',
                        !value && 'text-muted-foreground',
                        className,
                    )}
                    data-testid={testId}
                >
                    <CalendarIcon size={14} className="mr-2" strokeWidth={1.6} />
                    {value ? format(dateValue, 'd MMM yyyy', { locale: fr }) : placeholder}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
                <Calendar
                    mode="single"
                    selected={dateValue}
                    onSelect={(d) => {
                        if (!d) { onChange(''); return; }
                        const y = d.getFullYear();
                        const m = String(d.getMonth() + 1).padStart(2, '0');
                        const day = String(d.getDate()).padStart(2, '0');
                        onChange(`${y}-${m}-${day}`);
                    }}
                    locale={fr}
                    initialFocus
                />
            </PopoverContent>
        </Popover>
    );
}
